import React, { useEffect, useState } from "react";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { getFiltrarLocales, getFiltrarPromociones, postCierreDeCaja, postGiftCardReporte, postReporteCaja } from "../../../../../api/ApiService";
import { Download, FileSpreadsheet } from "lucide-react";
import { useSelector } from "react-redux";

export const statusOptions = [
    { label: "Reporte Compra GiftCard", value: "Reporte Compra GiftCard", id: 1 },
    { label: "Reporte Canjes Giftcard", value: "Reporte Canjes Giftcard", id: 2 },
    { label: "Reporte Canjes Giftcard Gentileza", value: "Reporte Canjes Giftcard Gentileza", id: 3 },
    { label: "Reporte Compras y Canjes", value: "Reporte Compras y Canjes", id: 4 },
    // { label: "Reporte Caja", value: "Reporte Caja", id: 5 },
    { label: "Cierre de Caja", value: "Cierre de Caja", id: 6 },
];



function ReportesGiftCard() {
    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const [loadingCargar, setLoadingCargar] = useState(false);
    const [tipoReporte, setTipoReporte] = useState(statusOptions[0].value);
    const [fechaDesde, setFechaDesde] = useState("");
    const [fechaHasta, setFechaHasta] = useState("");
    const [reportePath, setReportePath] = useState("");
    const [reporteUrl, setReporteUrl] = useState("");






    //estado alert
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');

    const inputBaseClass =
        "w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200";

    const handleGenerarReporte = () => {
        if (!tipoReporte || !fechaDesde || !fechaHasta) {
            // alert("Debes seleccionar tipo de reporte, fecha desde y fecha hasta.");
            setSeverity('error');
            setMensaje("Debes seleccionar tipo de reporte, fecha desde y fecha hasta.");
            setOpen(true);
            return;
        }

        if (fechaDesde > fechaHasta) {
            // alert("La fecha desde no puede ser mayor a la fecha hasta.");
            setSeverity('error');
            setMensaje("La fecha desde no puede ser mayor a la fecha hasta.");
            setOpen(true);
            return;
        }

        // Validacion para Cierre de Caja: las fechas deben ser iguales
        if (tipoReporte === "Cierre de Caja" && fechaDesde !== fechaHasta) {
            setSeverity('error');
            setMensaje("Para el reporte de Cierre de Caja, la fecha desde y fecha hasta deben ser iguales.");
            setOpen(true);
            return;
        }

        const body = {
            tipo_reporte: tipoReporte,
            fecha_desde: fechaDesde,
            fecha_hasta: fechaHasta,
        };



        setLoadingCargar(true);
        setReportePath("");
        setReporteUrl("");

        if (tipoReporte === "Cierre de Caja") {

            const bodyCierreCaja = {
                fecha_desde: fechaDesde,
                fecha_hasta: fechaHasta,
            };

            postCierreDeCaja(stateToken?.access_token, bodyCierreCaja)
                .then((response) => {
                    setReportePath(response?.path || "");
                    setReporteUrl(response?.url || "");
                })
                .catch((error) => {
                    console.log("error==>postCierreDeCaja", error);
                    setSeverity('error');
                    setMensaje("No se pudo generar el reporte de cierre de caja. Intenta nuevamente.");
                    setOpen(true);
                })
                .finally(() => {
                    setLoadingCargar(false);
                });
        } else if (tipoReporte === "Reporte Caja") {

            const bodyCaja = {
                fecha_desde: fechaDesde,
                fecha_hasta: fechaHasta,
            };

            postReporteCaja(stateToken?.access_token, bodyCaja)
                .then((response) => {
                    setReportePath(response?.data?.path || "");
                    setReporteUrl(response?.data?.url || "");
                })
                .catch((error) => {
                    console.log("error==>postReporteCaja", error);
                    setSeverity('error');
                    setMensaje("No se pudo generar el reporte. Intenta nuevamente.");
                    setOpen(true);
                })
                .finally(() => {
                    setLoadingCargar(false);
                });
        } else {

            postGiftCardReporte(stateToken?.access_token, body)
                .then((response) => {
                    setReportePath(response?.path || "");
                    setReporteUrl(response?.url || "");
                })
                .catch((error) => {
                    console.log("error==>postGiftCardReporte", error);
                    setSeverity('error');
                    setMensaje("No se pudo generar el reporte. Intenta nuevamente.");
                    setOpen(true);
                })
                .finally(() => {
                    setLoadingCargar(false);
                });
        }
    };

    const handleDescargarXlsx = () => {
        if (!reporteUrl) {
            setSeverity('warning');
            setMensaje("Primero debes generar el reporte.");
            setOpen(true);
            return;
        }

        const fileNameFromPath = reportePath?.split("/")?.pop() || "reporte_giftcard.xlsx";

        let rUrl = reporteUrl;
        if (window.location.protocol === 'https:' && rUrl.startsWith('http://')) {
            rUrl = rUrl.replace('http://', 'https://');
        }

        const link = document.createElement("a");
        link.href = rUrl;
        link.setAttribute("download", fileNameFromPath);
        link.setAttribute("target", "_blank");
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const handleClose = () => {
        setOpen(false);
    };















  




    return (
            <div className="min-h-screen bg-gray-100">


                <div className="mx-auto max-w-7xl">
                    <div className="rounded-xl border border-gray-200 bg-white p-4 md:p-6">
                        <div className="mb-5 flex items-center gap-3">
                            <div className="rounded-xl bg-emerald-50 p-2.5">
                                <FileSpreadsheet className="h-5 w-5 text-emerald-600" />
                            </div>
                            <div>
                                <h2 className="text-xl font-bold text-gray-800">Reportes GiftCard</h2>
                                <p className="text-sm text-gray-500">Selecciona filtros para generar y descargar el XLSX</p>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                            <div>
                                <label className="mb-1.5 block text-sm font-semibold text-gray-700">Tipo de reporte</label>
                                <select
                                    value={tipoReporte}
                                    onChange={(e) => setTipoReporte(e.target.value)}
                                    className={inputBaseClass}
                                >
                                    {statusOptions.map((option) => (
                                        <option key={option.id} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="mb-1.5 block text-sm font-semibold text-gray-700">Fecha desde</label>
                                <input
                                    type="date"
                                    value={fechaDesde}
                                    onChange={(e) => setFechaDesde(e.target.value)}
                                    className={inputBaseClass}
                                />
                            </div>

                            <div>
                                <label className="mb-1.5 block text-sm font-semibold text-gray-700">Fecha hasta</label>
                                <input
                                    type="date"
                                    value={fechaHasta}
                                    onChange={(e) => setFechaHasta(e.target.value)}
                                    className={inputBaseClass}
                                />
                            </div>
                        </div>

                        <div className="mt-6 flex flex-col gap-3 md:flex-row">
                            <button
                                type="button"
                                onClick={handleGenerarReporte}
                                className="inline-flex items-center justify-center rounded-lg bg-[#104063] px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#0d3553]"
                            >
                                Generar reporte
                            </button>

                            <button
                                type="button"
                                onClick={handleDescargarXlsx}
                                disabled={!reporteUrl}
                                className="inline-flex items-center justify-center gap-2 rounded-lg bg-emerald-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-50"
                            >
                                <Download className="h-4 w-4" />
                                Descargar XLSX
                            </button>
                        </div>

                        {reporteUrl && (
                            <div className="mt-4 rounded-lg border border-emerald-100 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
                                Reporte generado correctamente. Ya puedes descargar el archivo.
                            </div>
                        )}
                    </div>
                </div>




                <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} autoHideDuration={2000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                        {mensaje}
                    </Alert>
                </Snackbar>

                <Backdrop open={loadingCargar} sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
    );
}

export default ReportesGiftCard;